module.exports = __webpack_public_path__ + "fd736bf4b0bb8eff23347a642a003cee.svg";